import { createFileRoute } from "@tanstack/react-router";

import { Navigate } from "@/lib/router-compat";
export const Route = createFileRoute("/singles-dinner-events")({
  component: () => <Navigate to="/singles-dinner-experiences" replace />,
});
